import React, { useState, useEffect } from 'react';
import axios from 'axios';
import apiUrl from '../../Environment/Api';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function Invoiceadd() {
    const navigate = useNavigate();
    const [exchangeRate, setExchangeRate] = useState('');
    const [currentDate, setCurrentDate] = useState(getFormattedDate());
    const [getinvoiceno, setinvoiceno] = useState('');

    const formatdateinvoice = new Date(currentDate);
    const [getinvoicejustno, setinvoicejustno] = useState('');



    useEffect(() => {
        clientdetails();
        invoiceno();
        categorytype();
        const fetchExchangeRate = async () => {
            try {
                const response = await fetch('https://api.frankfurter.app/latest?from=USD&to=INR');
                const data = await response.json();
                const usdToInrRate = data.rates.INR;
                setExchangeRate(usdToInrRate);

            } catch (error) {
                console.error('Error fetching exchange rate:', error);
            }
        };
        fetchExchangeRate();


    }, [currentDate]);





    const [selectedClient, setSelectedClient] = useState('');
    // const [selectedType, setSelectedType] = useState('');
    const [tableData, setTableData] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const [tax, setTax] = useState(0);
    const [netTotal, setNetTotal] = useState(0);
    const [clientRowCreated, setClientRowCreated] = useState(false);
    const [selectedTypeDataArray, setSelectedTypeDataArray] = useState([]);



    const [getclientaddress, setclientaddress] = useState('')
    const [getclientcountry, setclientcountry] = useState('')
    const [getclientName, setclientName] = useState('');
    const [getclientmobile, setclientmobile] = useState('');


    const handleClientChange = async (event) => {
        const clientValue = event.target.value;
        setSelectedClient(clientValue);

        // Export client details
        const clientaddresscountryfilter = ClientDetails.filter((data) => data.id === parseInt(clientValue, 10));
        setclientName(clientaddresscountryfilter[0].clientName);
        setclientaddress(clientaddresscountryfilter[0].address);
        setclientcountry(clientaddresscountryfilter[0].countrycode);
        setclientmobile(clientaddresscountryfilter[0].mobile);

        if (!clientRowCreated && clientValue !== '') {
            // Create a new row for the table data array
            const newId = Date.now();
            const newDate = getFormattedDate();
            setTableData([{ id: newId, date: newDate, projectName: '', type: '', quantity: 1, price: 0, tax: '' }]);
            setClientRowCreated(true);
        } else {
            setClientRowCreated(false);
        }
    };
    const [selectedType, setSelectedType] = useState({});
    const handleTypeChange = (index, value) => {
        if (value !== '') {
            const updatedTableData = tableData.map((item, i) => {
                if (i === index) {
                    const selectedTypeData = getCategoryType.find((category) => category.type === value);

                    return {
                        ...item,
                        type: value,
                        price: getclientcountry === '91' ? selectedTypeData.INRprice : selectedTypeData.price,
                    };
                }
                return item;
            });

            if (index === updatedTableData.length - 1) {
                const newId = Date.now();
                const newRow = {
                    id: newId,
                    date: getFormattedDate(),
                    projectName: '',
                    type: '',
                    quantity: 1,
                    price: 0,
                    tax: '',
                };
                updatedTableData.push(newRow);
                setClientRowCreated(true);
            }

            setTableData(updatedTableData);


        }
    };





    const handleUserInputChange = (index, property, value) => {
        console.log('handleUserInputChange triggered:', index, property, value);
        const updatedTableData = [...tableData];
        updatedTableData[index][property] = value;
        setTableData(updatedTableData);
    };

    useEffect(() => {

        let newSubtotal = 0;
        let newTax = 0;

        tableData.forEach((item) => {
            const quantity = parseFloat(item.quantity) || 0;
            const price = parseFloat(item.price) || 0;
            const itemSubtotal = quantity * price;
            const itemTax = (parseFloat(item.tax) || 0) * itemSubtotal / 100;

            newSubtotal += itemSubtotal;
            newTax += itemTax;
        });

        setSubtotal(newSubtotal);
        setTax(newTax);

        const newNetTotal = newSubtotal + newTax;
        setNetTotal(newNetTotal);
        if (clientRowCreated && selectedClient !== '') {
            // Perform actions that depend on updated state
            // For example, you can trigger the type change for the new row
            // handleTypeChange(0, tableData[0].type);
        }
    }, [clientRowCreated, selectedClient, tableData]);

    const tablerowdelete = (ItemId) => {
        setTableData((prevItems) => {
            console.log('Before deletion:', prevItems);
            const newItems = prevItems.filter((item) => item.id !== ItemId);
            console.log('After deletion:', newItems);
            return newItems;
        });
    };


    const handleClearAll = () => {
        setTableData([]);
        setClientRowCreated(false);
    };

    const handleback = () => {
        navigate('/invoice');
    };

    //category type get 
    const [getCategoryType, setCategoryType] = useState([]);
    const categorytype = async () => {
        try {
            const response = await axios.get(apiUrl + '/category');
            if (response) {
                if (!response.length > 0) {
                    setCategoryType(response.data)
                    console.log("category type getted", response.data)
                }
            }
        }
        catch (err) {
            console.log(err);
        }
    }



    // to get client details ---------------
    const [ClientDetails, setClientDetails] = useState([]);
    const clientdetails = async () => {
        try {
            const response = await axios.get(apiUrl + "/clientdetailsfull");
            if (response) {
                setClientDetails(response.data);
            }
        } catch (error) {
            console.error("Error fetching client details:", error);
        }
    };

    // get invoice no. ----------------------------

    const [getinvoicedatelabel, setinvoicedatelabel] = useState('');


    const invoiceno = async () => {
        try {
            const response = await axios.get(apiUrl + '/invoiceno');
            console.log("the response for invoice no ---------------", response);

            const updatedInvoiceJustNo = response.data.invoiceId;

            setinvoicejustno(updatedInvoiceJustNo); // Use setinvoicejustno consistently

            console.log("get invoice ----------------------", updatedInvoiceJustNo);

            const formattedDate = `${formatdateinvoice.getFullYear().toString().slice(-2)}${(formatdateinvoice.getMonth() + 1).toString().padStart(2, '0')}`;
            setinvoicedatelabel(formattedDate);
            const invoicedata = `VAS${formattedDate}-${updatedInvoiceJustNo}`; // Use updatedInvoiceJustNo instead of getinvoicejustno

            setinvoiceno(invoicedata);
        } catch (err) {
            console.log(err);
        }
    };


    // get current date---------------------------------------
    function getFormattedDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month = today.getMonth() + 1;
        let day = today.getDate();

        month = month < 10 ? `0${month}` : month;
        day = day < 10 ? `0${day}` : day;

        return `${year}-${month}-${day}`;
    }



    const validateForm = () => {
        const emptyFields = [];
        if (selectedClient === '') {
            emptyFields.push('Client Name');
        }
        if (currentDate === '') {
            emptyFields.push('Date');
        }
        if (getData.dueDate === '') {
            emptyFields.push('Due Date');
        }
        if (tax === '') {
            emptyFields.push('Tax');
        }
        tableData.forEach((item, index) => {
            if (item.type !== '') {
                if (item.projectName === '') {
                    emptyFields.push(`Project Name at row ${index + 1}`);
                }
                if (item.tax === '') {
                    emptyFields.push(`Tax at row ${index + 1}`);
                }
                if (item.quantity === '') {
                    emptyFields.push(`Quantity at row ${index + 1}`);
                }
                if (item.price === '') {
                    emptyFields.push(`Price at row ${index + 1}`);
                }
            }
        });
        if (emptyFields.length > 0) {
            alert(`Please fill in the following required fields: ${emptyFields.join(', ')}`);
            return false;
        }
        return true;
    };


    const [isDataSubmitted, setIsDataSubmitted] = useState(false);
    // submit data
    const [getData, setData] = useState({
        invoiceId: '',
        clientName: '',
        date: '',
        dueDate: '',
        notes: '',
        totalTax: '',
        paymentStatus: 'Unpaid',
        totalAmount: '',
        paymentDate: '',
        getinvoicedatelabel: ''
    });


    const toaster = (callback) => {
        toast.success('Data submitted successfully!', {
            autoClose: 1000,
            hideProgressBar: true,
            onClose: callback
        });
    };

    // submit data
    const submitdata = async () => {
        const isValid = validateForm();
        if (!isDataSubmitted) {
            if (isValid) {
                try {
                    setIsDataSubmitted(true);
                    const updatedTableData = [...tableData];
                    setTableData(updatedTableData);
                    const filteredTableData = updatedTableData.filter(item => item.type.trim() !== '');

                    const newData = {
                        invoiceId: getinvoiceno,
                        clientName: selectedClient,
                        date: currentDate,
                        dueDate: getData.dueDate,
                        totalAmount: netTotal.toFixed(2),
                        notes: getData.notes,
                        totalTax: tax.toFixed(2),
                        paymentStatus: 'Unpaid',
                        paymentDate: '',
                        getinvoicedatelabel: ''
                    };

                    const requestData = { ...getData, ...newData };

                    console.log("submit data", requestData);

                    const response = await axios.post(apiUrl + '/invoicedetails', requestData);

                    console.log(response.data);

                    if (response.data.status === 'success') {

                        const invoicelistData = filteredTableData.map((item) => ({
                            invoiceId: getinvoiceno,
                            date: item.date,
                            clientName: selectedClient,
                            projectName: item.projectName,
                            type: item.type,
                            quantity: item.quantity,
                            price: item.price,
                            tax: item.tax,
                            totalAmount: (
                                parseFloat(item.quantity) * parseFloat(item.price) +
                                (parseFloat(item.tax) * parseFloat(item.quantity) * parseFloat(item.price)) / 100
                            ).toFixed(2),
                        }));


                        try {
                            const response = await axios.post(apiUrl + '/invoicelist', invoicelistData);
                            console.log("invoicelist data", response.data);
                            toaster(() => navigate('/invoice'));


                        } catch (err) {
                            console.log("Error in invoicelist request:", err);
                        }

                    } else {
                        console.log("Error in invoicedetails response:", response.data.error);
                    }


                } catch (err) {
                    console.log("Error in submitdata function:", err);
                }

            } else {
                console.log("Data has already been submitted");
            }

        }
    };


    // const [getlastinvoiceno, setlastinvoiceno] = useState('')
    const handlenavigate = async () => {
        const isValid = validateForm();
        if (isValid) {
            try {
                await submitdata();
                try {
                    const response = await axios.get(apiUrl + '/invoicenoget');
                    console.log("response id ", response.data)
                    // setlastinvoiceno(response.data);
                    navigate(`/invoice/invoiceprint/${response.data}`, {
                       
                    });
                }
                catch (error) {
                    console.log(error)
                }


                // navigate('/bill', {
                //     state: {
                //         invoiceData: {
                //             invoiceId: getinvoiceno,
                //             currentDate,
                //             dueDate: getData.dueDate,
                //             getclientName,
                //             getclientaddress,
                //             getclientcountry,
                //             getclientmobile,
                //             tableData,
                //             subtotal,
                //             tax: tax.toFixed(2),
                //             netTotal,
                //             notes: getData.notes,

                //         }
                //     }
                // });
            } catch (error) {
                console.error('Error submitting data and navigating:', error);
            }
        }
    };



    return (
        <>
            <ToastContainer />
            <h3 className='text-center'>Invoice</h3>
            <hr />
            <div className='mx-1'>
                <div className="invoicebackground1">
                    <form className="row">
                        <div className="col-lg-3 col-md-4 col-sm-12">
                            <label className="form-label">Invoice No.</label>
                            <input className="form-control" value={getinvoiceno} type="text"></input>
                        </div>
                        <div className="col-lg-6 col-md-4"></div>
                        <div className="col-lg-3 col-md-4 col-sm-12">
                            <label className="form-label">Date :</label>
                            <input
                                className="form-control"
                                type="date"
                                value={currentDate}
                                onChange={(e) => setCurrentDate(e.target.value)}
                                required
                            />
                        </div>
                    </form>
                </div>
                <div className="invoicebackground1">
                    <form className="row">
                        <div className="col-lg-3 col-md-4 col-sm-12">
                            <div className='dropdown'>
                                <label className="form-label">Client Name :</label>
                                <div className="position-relative">
                                    <select className='form-control dropdown-toggle custom-select' value={selectedClient} onChange={handleClientChange}>
                                        <option value="">Select an option</option>
                                        {ClientDetails.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.clientName}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="dropdown-arrow"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4"></div>
                        <div className='col-lg-3'></div>
                        <div className="col-lg-3 col-md-4 col-sm-12">
                            <form className='control'>
                                <label className='form-label'>Due Date</label>
                                <input className='form-control' value={getData.dueDate} type='date' onChange={(e) => {
                                    setData({ ...getData, dueDate: e.target.value });
                                }} required />
                            </form>
                        </div>
                    </form>
                </div>
                <div className="invoicebackground1">
                    <div className='table-responsive'>
                        <table className='table table-bordered'>
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th style={{ width: '20%' }}>Project Name</th>
                                    <th style={{ width: '15%' }}>Type</th>
                                    <th style={{ width: '6%' }}>Qty</th>
                                    <th style={{ width: '10%' }}>Price</th>
                                    <th style={{ width: '10%' }}>Paypal Tax(%)</th>
                                    {getclientcountry === "91" ? null : <th style={{ width: '10%' }}>₹ Amount</th>}
                                    <th style={{ width: '10%' }}>Rate </th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map((item, index) => (
                                    <tr key={item.id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>
                                            <input
                                                className='form-control'
                                                type="date"
                                                value={item.date}
                                                onChange={(e) => handleUserInputChange(index, 'date', e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <td>
                                                <input style={{ width: '100%' }}
                                                    className='form-control'
                                                    type="text"
                                                    value={item.projectName}
                                                    onChange={(e) => handleUserInputChange(index, 'projectName', e.target.value)}
                                                />
                                            </td>

                                        </td>
                                        <td>
                                            <div className="position-relative">
                                                <select
                                                    className='form-control dropdown-toggle custom-select'
                                                    value={tableData[index].type}
                                                    onChange={(e) => handleTypeChange(index, e.target.value)}
                                                >
                                                    <option value="">Select a type</option>
                                                    {getCategoryType
                                                        .filter(item =>
                                                            (getclientcountry === "91" && item.INRprice !== '') ||
                                                            (getclientcountry !== "91" && item.price !== '')
                                                        )
                                                        .map((item) => (
                                                            <option key={item.id} value={item.type}>
                                                                {item.type}
                                                            </option>
                                                        ))}
                                                </select>
                                                <div className="dropdown-arrow"></div>
                                            </div>
                                        </td>
                                        <td>
                                            <input
                                                className='form-control'
                                                type="tel"
                                                value={item.quantity}
                                                onChange={(e) => {
                                                    const size = e.target.value.replace(/\D/g, '').slice(0, 30);
                                                    handleUserInputChange(index, 'quantity', size)
                                                }
                                                }
                                            />
                                        </td>
                                        {/* <td>
                                            <input
                                                className='form-control'
                                                type="tel"
                                                value={getclientcountry === "91" ? `₹${item.price}` : `$${item.price}`}
                                                onChange={(e) => {
                                                    const size = e.target.value.replace(/\D/g, '').slice(0, 30);
                                                    handleUserInputChange(index, 'price', size.replace('$', ''))
                                                }}
                                            />


                                        </td> */}
                                        <td>
                                            <input
                                                className='form-control'
                                                type="tel"
                                                value={getclientcountry === "91" ? `₹${tableData[index].price}` : `$${tableData[index].price}`}



                                                onChange={(e) => {
                                                    const size = e.target.value.replace(/\D/g, '').slice(0, 30);
                                                    handleUserInputChange(index, 'price', size.replace('$', ''))
                                                }}
                                            />
                                        </td>

                                        <td>
                                            <input
                                                className='form-control'
                                                type="number"
                                                value={item.tax}
                                                placeholder="Enter Tax"
                                                onChange={(e) => handleUserInputChange(index, 'tax', e.target.value)}
                                            />
                                        </td>
                                        {getclientcountry === "91" ? null : (
                                            <td>

                                                <p>₹ {(((parseFloat(item.quantity) * parseFloat(item.price)) + parseFloat(item.tax * item.quantity * item.price / 100)) * exchangeRate).toFixed(2)}</p>

                                            </td>
                                        )}
                                        <td>
                                            <p>
                                                {getclientcountry === "91"
                                                    ? `₹ ${(parseFloat(item.quantity) * parseFloat(item.price) + parseFloat(item.tax * item.quantity * item.price / 100)).toFixed(2)}`
                                                    : `$ ${(parseFloat(item.quantity) * parseFloat(item.price) + parseFloat(item.tax * item.quantity * item.price / 100)).toFixed(2)}`
                                                }
                                            </p>
                                        </td>

                                        <td>
                                            <button
                                                className="btn btn-button mx-2 px-2 deletebutton"
                                                onClick={() => tablerowdelete(item.id)}
                                            >
                                                <i className="fa-solid fa-trash"></i>
                                            </button>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="row mt-4">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <label className='form-label'><b>Notes :</b>
                                <br />
                                <textarea
                                    className='form-control notes-textarea'
                                    type='text'
                                    value={getData.notes}
                                    onChange={(e) => {
                                        setData({ ...getData, notes: e.target.value })
                                    }}
                                    required
                                />
                            </label>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <form>
                                <div className=" row">
                                    <div className="col-lg-5 col-md-6 mt-1">
                                        <label className="form-label"><b>Sub Total</b></label>
                                    </div>
                                    <div className="col-lg-7 col-md-6">
                                        <input
                                            className="form-control"
                                            value={getclientcountry === "91" ? `₹${subtotal.toFixed(2)}` : `$${subtotal.toFixed(2)}`}
                                            type="text"
                                            placeholder="Sub Total"
                                        />

                                    </div>
                                </div>
                                <div className=" row mt-3">
                                    <div className="col-lg-5 col-md-6 mt-1">
                                        <label className="form-label"><b>Paypal Tax</b></label>
                                    </div>
                                    <div className="col-lg-7 col-md-6">
                                        <input
                                            className="form-control"

                                            value={getclientcountry === "91" ? `₹${tax.toFixed(2)}` : `$${tax.toFixed(2)}`}
                                            type="text"
                                            placeholder="Tax"
                                        />
                                    </div>
                                </div>
                                <div className=" row mt-3">
                                    <div className="col-lg-5 col-md-6 mt-1">
                                        <label className="form-label"><b>Net Total</b></label>
                                    </div>
                                    <div className="col-lg-7 col-md-6">
                                        <input
                                            className="form-control"
                                            value={getclientcountry === "91" ? `₹${netTotal.toFixed(2)}` : `$${netTotal.toFixed(2)}`}
                                            type="text"
                                            placeholder="Net Total"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-5'>

                        </div>
                        <div className='col-lg-7'>
                            <div style={{ marginLeft: "75px" }} className="d-flex justify-content-evenly mt-3 buttonstyle ">
                                <button type="button" className="btn btn-danger invoice-button" onClick={handleClearAll}>Clear</button>
                                <button type="button" className="btn btn-info text-white invoice-button" style={{ backgroundColor: '#007BFF' }} onClick={handleback}>Back</button>
                                <button type="button" className="btn btn-success invoice-button" onClick={submitdata}>Save</button>
                                <button type="button" className="btn btn-secondary invoice-button" onClick={handlenavigate}>Print</button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}
export default Invoiceadd;